import { Component } from '@angular/core';

@Component({
  selector: 'survey-main-container',
  templateUrl: './survey-main-container.component.html',
  styleUrls: ['./survey-main-container.component.scss']
})
export class SurveyMainContainerComponent {

}
